module.exports = __webpack_public_path__ + "img/menu-contract.585b28f6.svg";